import { Box, Grid, Button } from "@material-ui/core";
import OrderTypeTable from "./OrderTyepsTable";
import OrderTypeModal from "./OrderTypeModal";

const Orders = ({ orders, modalState }) => {
  const totalOrdersNumber = orders.value.length;
  return (
    <>
      <OrderTypeModal open={modalState} />
      <Grid container style={{ padding: "5px 16px" }}>
        <Box
          sx={{
            width: "100%",
            typography: "body1",
            background: "white",
          }}
          style={{
            boxShadow: "0 1px 1px 0 #999",
            borderRadius: "5px",
          }}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={12} sm={8} md={8} lg={8}>
              <h3 style={{ padding: "0px 16px" }}>
                دستورات سیستم ({totalOrdersNumber})
              </h3>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={4}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                style={{ color: "#fff", margin: "10px 12px" }}
                variant="contained"
                color="secondary"
                onClick={() => modalState.handleChange(true)}
              >
                افزودن دستور
              </Button>
            </Grid>
          </Grid>
          <OrderTypeTable orders={orders} />
        </Box>
      </Grid>
    </>
  );
};
export default Orders;
